import { useTranslation } from "react-i18next";

export function useCrossCheckSteps() {
  const { t } = useTranslation("tours");
  return [
    {
      target: '[data-testid="crosscheck-panel"]',
      title: t("crosscheck.step1.title"),
      content: t("crosscheck.step1.content"),
    },
    {
      target: '[data-testid="crosscheck-histogram-card"]',
      title: t("crosscheck.step2.title"),
      content: t("crosscheck.step2.content"),
    },
    {
      target: '[data-testid="crosscheck-list-card"]',
      title: t("crosscheck.step3.title"),
      content: t("crosscheck.step3.content"),
    },
  ];
}
